import { render, staticRenderFns } from "./productShow.vue?vue&type=template&id=1c178269&scoped=true&"
import script from "./productShow.vue?vue&type=script&lang=js&"
export * from "./productShow.vue?vue&type=script&lang=js&"
import style0 from "./productShow.vue?vue&type=style&index=0&id=1c178269&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c178269",
  null
  
)

export default component.exports